import React, { type PropsWithChildren } from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';

const libraries = ['places', 'geometry'];
const APP_GOOGLE_MAPS_API_KEY = process.env.GATSBY_GOOGLE_MAPS_API_KEY || '';

const GoogleMapsProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <APIProvider apiKey={APP_GOOGLE_MAPS_API_KEY} version="beta" language="en" region="US" libraries={libraries}>
      {children}
    </APIProvider>
  );
};

export default GoogleMapsProvider;
